import { createFileRoute, Outlet } from '@tanstack/react-router';
import { SEO } from 'components/Seo/Seo';
import useAppLanguage from 'hooks/useAppLanguage';
import messages from './messages';

export const Route = createFileRoute('/auth/login')({
  component: LoginView,
});

export default function LoginView() {
  const language = useAppLanguage();
  const loginViewMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={loginViewMessages.title}
        description={loginViewMessages.description}
        keywords={loginViewMessages.keywords}
        page="login"
      />
      <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="justify-center lg:px-8 sm:px-3 sm:py-12">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
